let isLoggingOut = false;
let resetTimer: ReturnType<typeof setTimeout> | null = null;

export const setLoggingOut = () => {
  isLoggingOut = true;
  if (resetTimer) clearTimeout(resetTimer);
  resetTimer = setTimeout(() => {
    isLoggingOut = false;
    resetTimer = null;
  }, 5000);
};

export const getIsLoggingOut = () => isLoggingOut;
